import { useCallback } from 'react';
import generateState from './utils/generateState';
import getLoginUrl from './utils/getLoginUrl';
import { useLocation } from 'react-router';
import { OAUTH_REDIRECT_ROUTE, OAUTH_STATE } from 'config/constants';

export interface Result {
  login: (options?: { noPrompt?: boolean }) => void;
}

const useOAuthLogin = (): Result => {
  const location = useLocation();

  const login = useCallback(
    (options) => {
      if (location.pathname.startsWith('/auth')) {
        return;
      }

      const state = generateState();

      window.sessionStorage.setItem(OAUTH_STATE, state);
      window.sessionStorage.setItem(OAUTH_REDIRECT_ROUTE, location.pathname);

      window.location.href = getLoginUrl(state, options?.noPrompt);
    },
    [location],
  );

  return {
    login,
  };
};

export default useOAuthLogin;
